<template>
  <v-card>
    <v-card-title class="py-3 px-4 border-bottom">
      <span class="gray--text text--darken-3 font-weight-regular">
        İstifadəçi şifrəsinin yenilənməsi
      </span>
    </v-card-title>
    <v-card-text>
      <v-form
        id="updatePasswordForm"
        ref="form"
        v-model="formValidation"
        lazy-validation
        @submit.prevent="handleFormSubmit"
      >
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Şifrə"
              filled
              required
              maxlength="20"
              minlength="6"
              v-model="formData.password"
              :rules="formRules.password"
              :type="isPasswordVisible ? 'text' : 'password'"
              :append-icon="getPasswordInputIcon(isPasswordVisible)"
              @click:append="togglePasswordVisibility"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              label="Şifrənin təkrarı"
              filled
              required
              maxlength="20"
              minlength="6"
              v-model="formData.passwordRepeat"
              :rules="formRules.passwordRepeat"
              :type="isPasswordRepeatVisible ? 'text' : 'password'"
              :append-icon="getPasswordInputIcon(isPasswordRepeatVisible)"
              @click:append="togglePasswordRepeatVisibility"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="py-3 px-4 d-flex justify-end border-top">
      <v-btn color="gray lighten-3" depressed @click="toggleDialog(null)">
        Bağla
      </v-btn>
      <v-btn
        :loading="isSubmittingForm"
        type="submit"
        form="updatePasswordForm"
        color="success"
        depressed
      >
        Yenilə
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    toggleDialog: {
      type: Function,
      required: true,
    },
    isSubmittingForm: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isPasswordVisible: false,
      isPasswordRepeatVisible: false,
      formValidation: false,
      formData: {
        password: "",
        passwordRepeat: "",
      },
      formRules: {
        password: [
          (v) => !!v || "Şifrəni daxil edin",
          (v) =>
            (!!v && v.length >= 6 && v.length <= 20) ||
            "Şifrənin uzunlugu ən az 6 və ən çox 20 simvol ola bilər",
          (v) =>
            /^(?!\.)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[.#$^+=!*()@%&]).{6,20}$/.test(
              v
            ) ||
            "Şifrədə ən az bir kiçik və bir böyük hərf, bir rəqəm və ən az bir simvol olmalıdır (.#$^+=!*()@%&)",
        ],
        passwordRepeat: [
          (v) => !!v || "Şifrənin təkrarını daxil edin",
          (v) =>
            (!!v && v.length >= 6 && v.length <= 20) ||
            "Şifrənin uzunlugu ən az 6 və ən çox 20 simvol ola bilər",
          (v) =>
            /^(?!\.)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[.#$^+=!*()@%&]).{6,20}$/.test(
              v
            ) ||
            "Şifrədə ən az bir kiçik və bir böyük hərf, bir rəqəm və ən az bir simvol olmalıdır (.#$^+=!*()@%&)",
          (v) =>
            v === this.formData.password || "Şifrələr bir-birinə uyğun deyil",
        ],
      },
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
    togglePasswordRepeatVisibility() {
      this.isPasswordRepeatVisible = !this.isPasswordRepeatVisible;
    },
    getPasswordInputIcon(isVisible) {
      return isVisible ? "mdi-eye" : "mdi-eye-off";
    },
    handleFormSubmit() {
      const isFormValid = this.$refs.form.validate();
      if (isFormValid) {
        this.$emit("formSubmit", this.formData);
      }
    },
  },
};
</script>
